import { Space } from 'antd';
import { useFormikContext } from 'formik';
import FormInput from 'components/new-ui/composed/formInput/FormInput';
import CustomerSelect from 'components/new-ui/composed/selects/CustomerSelect';
import { usePartyContext } from 'views/customers/customer/PartyProvider';
import { FieldLabel, FormCol, FormRow } from '../../Utils';
import { FormFields, FormValues } from '../../types';

type Props = {};

const BillingForm = (props: Props) => {
    const { customerId } = usePartyContext();
    const formik = useFormikContext<FormValues>();

    return (
        <Space direction="vertical" size={12} style={{ width: '100%' }}>
            <FormRow>
                <FormCol>
                    <FieldLabel htmlFor={FormFields.Billing.RECIPIENT_NAME}>Contact Name</FieldLabel>
                    <div>
                        <FormInput
                            inputStyles={{ maxWidth: '100%' }}
                            placeholder="Enter Recipient Name"
                            fieldProps={formik.getFieldProps(FormFields.Billing.RECIPIENT_NAME)}
                            fieldMeta={formik.getFieldMeta(FormFields.Billing.RECIPIENT_NAME)}
                            fieldHelper={formik.getFieldHelpers(FormFields.Billing.RECIPIENT_NAME)}
                        />
                    </div>
                </FormCol>
                <FormCol>
                    <FieldLabel htmlFor={FormFields.Billing.BILLING_EMAIL}>Billing Email</FieldLabel>
                    <div>
                        <FormInput
                            inputStyles={{ maxWidth: '100%' }}
                            placeholder="Enter Billing Email"
                            fieldProps={formik.getFieldProps(FormFields.Billing.BILLING_EMAIL)}
                            fieldMeta={formik.getFieldMeta(FormFields.Billing.BILLING_EMAIL)}
                            fieldHelper={formik.getFieldHelpers(FormFields.Billing.BILLING_EMAIL)}
                        />
                    </div>
                </FormCol>
            </FormRow>

            <FormRow>
                <FormCol>
                    <FieldLabel htmlFor={FormFields.Billing.BILLING_CUSTOMER_CODE}>Billing Customer Code</FieldLabel>
                    <div>
                        <FormInput
                            inputStyles={{ maxWidth: '100%' }}
                            placeholder="Enter Billing Customer Code"
                            fieldProps={formik.getFieldProps(FormFields.Billing.BILLING_CUSTOMER_CODE)}
                            fieldMeta={formik.getFieldMeta(FormFields.Billing.BILLING_CUSTOMER_CODE)}
                            fieldHelper={formik.getFieldHelpers(FormFields.Billing.BILLING_CUSTOMER_CODE)}
                        />
                    </div>
                </FormCol>
                <FormCol>
                    <FieldLabel htmlFor={FormFields.Billing.THIRD_PARTY_BILLING}>Third Party Billing</FieldLabel>
                    <CustomerSelect
                        style={{ maxWidth: '100%' }}
                        excludeIds={[customerId]}
                        customerId={formik.values.thirdPartyBilling ?? undefined}
                        onChange={(id) => formik.setFieldValue(FormFields.Billing.THIRD_PARTY_BILLING, id)}
                        onClear={() => formik.setFieldValue(FormFields.Billing.THIRD_PARTY_BILLING, undefined)}
                    />
                </FormCol>
            </FormRow>
        </Space>
    );
};

export default BillingForm;
